import OrdersGroup from "./OrdersGroup";
import OrdersHeader from "./OrdersHeader";

function Orders() {
  return (
    <div>
      <OrdersHeader />
      <OrdersGroup />
    </div>
  );
}

export default Orders;
